
import { motion, AnimatePresence } from "framer-motion";
import { Link } from 'react-router';
import SortIcon from "../../../pages/organization/emplyee-directory/component/sortIcon";
import { Eye, IdCard, Pencil } from "lucide-react";
import Style from './style.module.css';

const MainTable = ({isCheckBox, hiddenFields, tableHeader, userData, isSort, isEdit, isView, isRedirect }) => {
    return (
        <table className={Style.leave_table}>
            <thead>
                <tr>
                    
                    <th>
                        {isCheckBox?.isShow ?
                            <div className={Style.tableCheckBox}>
                                <label class={Style.custom_checkbox}>
                                    <input
                                        type="checkbox"
                                        ref={isCheckBox?.ref}
                                        className={Style.customCheckbox}
                                        onChange={isCheckBox?.func}
                                    />
                                    <span class={Style.checkmark}></span>
                                </label>
                            </div>
                            :
                            null
                        }
                    </th>
                    {
                        tableHeader.map((ele, idx) => {
                            if (ele?.is_visible) {
                                if (hiddenFields?.includes(ele?.key)) {
                                    return (
                                        null
                                    )
                                } else {
                                    return (
                                        <th key={`th-${idx}`}>
                                            <div className={Style.tableHeading}>
                                                <span className=''>{ele?.value}</span>
                                                {
                                                    isSort?.isShow ?
                                                    <>
                                                        {
                                                            (ele?.sort_by) ? (
                                                                <SortIcon
                                                                    field={ele?.key}
                                                                    sortFields={isSort?.sortFields}
                                                                    onSort={isSort?.func}
                                                                    Style={Style}
                                                                />
                                                            ) : (
                                                                <SortIcon
                                                                    disabled={true}
                                                                    field={ele?.key}
                                                                    Style={Style}
                                                                />
                                                            )
                                                        }
                                                    </>
                                                    :
                                                    null
                                                }
                                            </div>
                                        </th>
                                    )
                                }
                            } else {
                                return null;
                            }
                        })
                    }
                </tr>
            </thead>

            <tbody>
                {userData.map((ele, idx) => (
                    <motion.tr
                        key={ele.id || idx}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                    >
                        <td>
                            <div className={Style.tableActionArea}>
                                {isCheckBox?.isShow ?
                                    <div className={Style.tableCheckBox}>
                                        {
                                            (ele?.emp_is_active === 'Active') ? (
                                                <label class={Style.custom_checkbox}>
                                                    <input
                                                        type="checkbox"
                                                        className={Style.customCheckbox}
                                                        checked={isCheckBox?.selectedIds.includes(ele.employee_id)}
                                                        onChange={() => isCheckBox?.handleToggleOne(ele.employee_id)}
                                                    />
                                                    <span class={Style.checkmark}></span>
                                                </label>
                                            ) : (
                                                <>
                                                    <label class={Style.custom_checkbox}>
                                                        <input
                                                            type="checkbox"
                                                            className={Style.customCheckbox}
                                                            disabled
                                                        />
                                                        <span class={Style.checkmark}></span>
                                                    </label>
                                                </>
                                            )
                                        }
                                    </div>
                                    :
                                    null
                                }
                                {isEdit?.isShow ?
                                    <div className={Style.btn} onClick={() => isEdit?.func(ele)}>
                                        <div className={Style.icon} style={{ color: '#d97706' }}><Pencil className="h-4.5 w-4.5" /></div>
                                    </div>
                                    :
                                    null
                                }

                                {isView?.isShow ?
                                    <div className={Style.btn} onClick={() => { isView?.func(ele) }}>
                                        <div className={Style.icon} style={{ color: '#0284c7' }}><Eye className="h-4.5 w-4.5" /></div>
                                    </div>
                                    :
                                    null
                                }

                                {isRedirect?.isShow ?
                                    <Link to={`${isRedirect?.url}${ele[isRedirect?.eleKey]}`} className={Style.btn}>
                                        <div className={Style.icon} style={{ color: '#7f22fe' }}><IdCard className="h-4.5 w-4.5" /></div>
                                    </Link>
                                    :
                                    null
                                }

                            </div>
                        </td>
                        {
                            tableHeader.map((h_ele, h_idx) => {
                                if (h_ele?.is_visible) {
                                    if (h_ele?.key === "id" || h_ele?.key === "tenure") {
                                        return (
                                            null
                                        )
                                    } else if (h_ele?.key === "employee_id") {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                <div className={Style.nameCell}>
                                                    <span>{ele[h_ele?.key]}</span>
                                                </div>
                                            </td>
                                        )
                                    } else if (h_ele?.key === "profile_picture") {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                <div className={Style.userProfile_sm}>
                                                    {ele[h_ele?.key] ? (
                                                        <img src={ele[h_ele?.key]} alt={ele?.name} />
                                                    ) : (
                                                        <span>
                                                            {ele?.name
                                                                ?.split(' ')
                                                                .map(w => w[0])
                                                                .slice(0, 2)
                                                                .join('')
                                                                .toUpperCase()}
                                                        </span>

                                                    )}
                                                </div>
                                            </td>
                                        )
                                    } else if (h_ele?.key === "emp_is_active") {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                {
                                                    (ele[h_ele?.key] === 'Active') ? (
                                                        <span className={Style.active}>{ele[h_ele?.key] || '--'}</span>
                                                    ) : (
                                                        <span className={Style.inActive}>{ele[h_ele?.key] || '--'}</span>
                                                    )
                                                }
                                            </td>

                                        )
                                    } else if (h_ele?.key === "tenure_value") {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                {ele?.tenure || '--'}
                                            </td>
                                        )
                                    } else if (h_ele?.key === "email" || h_ele?.key === "p_personal_email") {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                <a href={`mailto:${ele[h_ele?.key]}` || ''}>
                                                    {ele[h_ele?.key] || '--'}
                                                </a>
                                            </td>
                                        )
                                    } else {
                                        return (
                                            <td key={`td-${h_idx}`}>
                                                {ele[h_ele?.key] || '--'}
                                            </td>
                                        )
                                    }
                                } else {
                                    return null;
                                }
                            })
                        }
                    </motion.tr>
                ))}
            </tbody>
        </table>
    )
}

export default MainTable;